/**
 * Electron Update Adapter
 * Delegates to electron-updater via IPC
 */

import type { UpdateAdapter, UpdateInfo, UpdateCallback } from './update.adapter';

export class ElectronUpdateAdapter implements UpdateAdapter {
  private callbacks: UpdateCallback[] = [];

  constructor() {
    // Listen for update events from main process
    window.electronAPI?.on('updater:update-available', (data) => {
      const info = data as UpdateInfo;
      this.callbacks.forEach((cb) => cb(info));
    });
  }

  async checkForUpdate(): Promise<UpdateInfo | null> {
    try {
      const result = await window.electronAPI?.invoke('updater:check');
      if (result && typeof result === 'object' && 'updateInfo' in (result as Record<string, unknown>)) {
        return (result as Record<string, unknown>).updateInfo as UpdateInfo;
      }
      return null;
    } catch {
      return null;
    }
  }

  async downloadUpdate(): Promise<boolean> {
    // electron-updater downloads automatically
    return true;
  }

  async installUpdate(): Promise<void> {
    await window.electronAPI?.invoke('updater:install');
  }

  onUpdateAvailable(callback: UpdateCallback): void {
    this.callbacks.push(callback);
  }
}
